(() => {
  const root = document.querySelector('.wl-ritual');
  if (!root) return;
  const es = document.documentElement.lang.startsWith('es');
  const t = (en, translated) => es ? translated : en;
  const video = root.querySelector('video');
  const stage = root.querySelector('.ritual-stage');
  const captions = [...root.querySelectorAll('[data-start]')];
  const chapters = [...root.querySelectorAll('.ritual-chapters button')];
  const play = root.querySelector('.ritual-play');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false, userPaused = reduced.matches, blocked = false, pending = false, raf = 0;
  let selectedTime = null;
  const duration = () => video.duration || 14.6;
  function render() {
    const time = video.currentTime;
    let active = 0;
    captions.forEach((item, i) => { if (time >= Number(item.dataset.start)) active = i; });
    captions.forEach((item, i) => { item.hidden = i !== active; });
    chapters.forEach((button, i) => {
      const start = Number(captions[i].dataset.start);
      const end = i + 1 < captions.length ? Number(captions[i + 1].dataset.start) : duration();
      button.style.setProperty('--progress', Math.min(1, Math.max(0, (time - start) / (end - start))));
      if (i === active) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
    const label = video.ended ? t('Replay film', 'Repetir video') : video.paused ? t('Play film', 'Reproducir video') : t('Pause film', 'Pausar video');
    play.setAttribute('aria-label', label);
    play.title = label;
    play.firstElementChild.textContent = video.ended ? '↻' : video.paused ? '▶' : 'Ⅱ';
  }
  function tick() {
    raf = 0;
    render();
    if (!video.paused && visible && !document.hidden) raf = requestAnimationFrame(tick);
  }
  function stop() {
    video.pause();
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
    render();
  }
  function start(fromGesture = false) {
    if (pending || userPaused || (!fromGesture && (blocked || !visible || document.hidden || video.ended))) return;
    pending = true;
    video.play().then(() => {
      blocked = false;
      if (userPaused || !visible || document.hidden) stop();
    }).catch(() => { blocked = true; }).finally(() => { pending = false; render(); });
  }
  root.classList.add('is-ready');
  root.querySelector('.ritual-toolbar').hidden = false;
  root.querySelector('.ritual-controls').hidden = false;
  video.controls = false;
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  render();
  const preload = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    video.preload = 'auto'; video.load(); preload.disconnect();
  }, {rootMargin:'600px'});
  preload.observe(root);
  video.addEventListener('loadedmetadata', () => {
    if (selectedTime !== null) { video.currentTime = selectedTime; selectedTime = null; }
    render();
  });
  for (const event of ['loadeddata', 'seeked', 'timeupdate', 'ended']) video.addEventListener(event, render);
  video.addEventListener('playing', () => { if (!raf) raf = requestAnimationFrame(tick); render(); });
  video.addEventListener('pause', () => { if (raf) cancelAnimationFrame(raf); raf = 0; render(); });
  video.addEventListener('error', () => {
    stop();
    root.querySelector('.ritual-error').hidden = false;
    root.querySelector('.ritual-controls').hidden = true;
    captions.forEach(item => { item.hidden = false; });
    root.classList.remove('is-ready');
  });
  play.addEventListener('click', () => {
    if (!video.paused || pending) { userPaused = true; stop(); return; }
    userPaused = false;
    if (video.ended) video.currentTime = 0;
    start(true);
  });
  chapters.forEach((button, i) => button.addEventListener('click', () => {
    const time = Number(captions[i].dataset.start);
    if (video.readyState >= 1) video.currentTime = time;
    else { selectedTime = time; video.preload = 'auto'; video.load(); }
    render();
    if (!userPaused) start(true);
  }));
  new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
    if (visible) start(); else stop();
  }, {threshold:[0, .35]}).observe(stage);
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else if (visible) start(); });
  reduced.addEventListener('change', () => { userPaused = reduced.matches; if (userPaused) stop(); else start(); });
})();
